import { EditorProviderButtonSettings } from '../EditorProviderButtonSettings';
import { customizeCraftJsComponent } from '../../helpers';
import { EditorButton } from '../EditorButton';

export const EditorDiscordButton = customizeCraftJsComponent(EditorButton, {
	name: 'Discord Button',
	props: {
		children: '',
		startIcon: 'discord',
		shape: 'square',
		variant: 'outline',
		'data-descope-provider': 'discord',
		startIconColorText: false,
		formNoValidate: true,
		'data-type': 'social'
	},
	related: {
		settings: EditorProviderButtonSettings
	},
	custom: {
		subType: 'social'
	}
});
